import { RefObject, useEffect, useRef } from 'react';
import { DIMENSION_INITIAL_VALUES } from './constants';

const getDimensions = (current: HTMLElement) => current.getBoundingClientRect();

const useElementDimensions = (elementRef: RefObject<HTMLElement>, dependencies: Array<unknown>) => {
  const dimensionsRef = useRef(DIMENSION_INITIAL_VALUES as DOMRect);

  useEffect(() => {
    if (!elementRef.current) return;

    const currentElement = elementRef.current;

    const handleResize = () => {
      dimensionsRef.current = getDimensions(currentElement);
    };

    dimensionsRef.current = getDimensions(currentElement);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDimensions, elementRef, ...dependencies]);

  return dimensionsRef.current;
};
export default useElementDimensions;
